import React from 'react';
import { Button } from './components/Button';

const MainCtaApp = props => <Button {...props} />;

export default MainCtaApp;
